<!-- <div>
  <input id="employeeName" name="employeeName"
         [style]="{minHeight:'24px', height:'24px', width: '100%'}" 
          class="ag-input-field-input ag-text-field-input"
          [(ngModel)]="employeeName"
          (input)="onFilterChanged($event)"/>
</div> -->


<div class="ag-floating-filter-input" role="presentation">
  <div role="presentation" ref="eFloatingFilterInput" class="ag-labeled ag-label-align-left ag-text-field ag-input-field">
  <div ref="eLabel" class="ag-input-field-label ag-label ag-hidden ag-text-field-label" role="presentation"></div>
  <div ref="eWrapper" class="ag-wrapper ag-input-wrapper ag-text-field-input-wrapper" role="presentation">
    <input id="employeeName" name="employeeName"
            [style]="{minHeight:'24px', height:'24px', width: '100%'}" 
            class="ag-input-field-input ag-text-field-input"
            [(ngModel)]="employeeName"
            (input)="onFilterChanged($event)"/>
  </div>
</div>
</div>